let ls = localStorage.getItem('ks_skin_quiz');
if (ls) {
    let ls_data = JSON.parse(ls).answers;
    if (ls_data.skin_type && ls_data.life_stage && ls_data.skin_concerns) {
        console.log('true');
        // document.getElementById('quiz-link--new').classList.add('is-hidden');
        // document.getElementById('quiz-link--existing').classList.remove('is-hidden');
        // document.getElementById('lg--retake-quiz-li').classList.remove('is-hidden');
        document.getElementById('hamberger--quiz-button--new').classList.add('is-hidden');
        document.getElementById('hamburger--results-link').classList.remove('is-hidden');
        document.getElementById('hamberger--retake-quiz-button').classList.remove('is-hidden');
    }
    
    const lg_retakeQuizBtn = document.getElementById('lg--retake-quiz-li');
    const sm_retakeQuizBtn = document.getElementById('hamberger--retake-quiz-button');
    
    if (sm_retakeQuizBtn) {
        sm_retakeQuizBtn.addEventListener('click', function() {
            console.log('Mobile quiz Reset button clicked');
            document.getElementById('hamberger--retake-quiz-link').classList.add('is-hidden');
            document.getElementById('hamberger--retake-quiz-loader').classList.remove('is-hidden');
            try {
                localStorage.removeItem('ks_skin_quiz');
            } catch (error) {
                console.log(error);
            }
            setTimeout(() => { 
            window.location.href = '/pages/skin-quiz-v2';
            }, "2000");
        })
    
    }
    
    if (lg_retakeQuizBtn) {
        lg_retakeQuizBtn.addEventListener('click', function() {
            console.log('Desktop Reset button clicked');
            document.getElementById('lg--retake-quiz-loader').classList.remove('is-hidden');
            document.getElementById('lg--retake-quiz-link').classList.add('is-hidden');
            try {
                localStorage.removeItem('ks_skin_quiz');
            } catch (error) {
                console.log(error);
            }
            setTimeout(() => { 
            window.location.href = '/pages/skin-quiz-v2';
            }, "2000");
        })
    };
} else {
    console.log('no storage found');
}